const API_BASE =
    (process.env.REACT_APP_BASE_API_URL || "").replace(/\/+$/, ""); // no trailing slash

function extractTokenFromStorage() {
    // Adjust to your app if you store it differently
    const raw =
        localStorage.getItem("token") ||
        localStorage.getItem("access_token") ||
        localStorage.getItem("auth_token") ||
        "";

    const token = raw.startsWith("Bearer ") ? raw.slice(7) : raw;
    return token || null;
}

function authHeaders(token) {
    const t = token || extractTokenFromStorage();
    return t ? { Authorization: `Bearer ${t}` } : {};
}

async function request(path, { method = "GET", token, body } = {}) {
    const url = `${API_BASE}${path}`;
    const res = await fetch(url, {
        method,
        headers: {
            Accept: "application/json",
            ...(body ? { "Content-Type": "application/json" } : {}),
            ...authHeaders(token),
        },
        body: body ? JSON.stringify(body) : undefined,
    });

    if (!res.ok) {
        const text = await res.text().catch(() => "");
        const msg = text || `HTTP ${res.status} ${res.statusText}`;
        const err = new Error(msg);
        err.status = res.status;
        throw err;
    }

    // 204 No Content
    if (res.status === 204) return null;

    return res.json();
}

export async function getUnreadCount({ token } = {}) {
    // returns { unread_count: number } or UnreadCountResource
    return request("/admin/notifications/unread-count", { token });
}

export async function listNotifications({perPage = 20, unreadOnly = false, token, page = 1} = {}) {
    const qs = new URLSearchParams();
    qs.set("per_page", String(perPage));
    qs.set("page", String(page));
    if (unreadOnly) qs.set("unread_only", "1");

    return request(`/admin/notifications?${qs.toString()}`, { token });
}

export async function markNotificationRead(id, { token } = {}) {
    return request(`/admin/notifications/${id}/read`, { method: "PATCH", token });
}

export async function markAllNotificationsRead({ token } = {}) {
    return request("/admin/notifications/read-all", { method: "POST", token });
}
